import type {
    ConversionRatesOvertimeListParams,
    ConversionRatesOvertimePopListParams,
} from "@similarweb/pro-api-client";

import { useApiQuery } from "app/modules/api-client";

type Options = { enabled: boolean };

export const useConversionRateData = (params: ConversionRatesOvertimeListParams, { enabled }: Options) =>
    useApiQuery(
        {
            tag: "WebConversionRates",
            methodName: "conversionRatesOvertimeList",
            options: { enabled, placeholderData: undefined },
        },
        params,
    );

export const useConversionRateDataPOP = (params: ConversionRatesOvertimePopListParams, { enabled }: Options) =>
    useApiQuery(
        {
            tag: "WebConversionRates",
            methodName: "conversionRatesOvertimePopList",
            options: { enabled, placeholderData: undefined },
        },
        params,
    );
